"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawsService = void 0;
var games_1 = require("../models/games");
var Promotion_1 = require("../models/promotion/Promotion");
var TimeUtil_1 = require("../utils/TimeUtil");
var api_1 = require("./api");
var PATH = 'game/api';
var PATH_V2 = 'game/api/v2';
var DRAW_PATH = 'game/player/api';
var DrawsService = /** @class */ (function () {
    function DrawsService() {
    }
    DrawsService.fetchPromotions = function (_a) {
        var page = _a.page, size = _a.size, sort = _a.sort;
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, promotions, last, totalPages, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestParams = ["page=" + (page || 0), "size=" + (size || 10)];
                        if (sort) {
                            requestParams.push("sort=" + sort);
                        }
                        else {
                            requestParams.push("sort=order,desc");
                            requestParams.push("sort=name,asc");
                        }
                        url = DRAW_PATH + "/promotions?promotionType.equals=SECOND_CHANCE&" + requestParams.join('&');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _b.sent();
                        promotions = Promotion_1.Promotion.JsonToEntities(response.content);
                        last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = Math.ceil((response.totalElements - 1) / response.size);
                        return [2 /*return*/, {
                                content: promotions,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_1 = _b.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchPromotionDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = DRAW_PATH + "/promotions/" + id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, Promotion_1.Promotion.JsonToEntity(response)];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawsByPromotion = function (id, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = ["page=" + (page || 0), "size=" + (size || 100)];
                        url = DRAW_PATH + "/draws?promotionId.equals=" + id + "&" + requestParams.join('&');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchGamesByPromotion = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = DRAW_PATH + "/promotions/" + id + "/games";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, games_1.Game.JsonToGames(response)];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDraws = function (_a) {
        var page = _a.page, size = _a.size, sort = _a.sort, type = _a.type, query = _a.query;
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, last, totalPages, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestParams = ["page=" + (page || 0), "size=" + (size || 10)];
                        if (sort) {
                            requestParams.push("sort=" + sort);
                        }
                        else {
                            requestParams.push("sort=start,desc");
                            requestParams.push("sort=name,asc");
                        }
                        if (type) {
                            requestParams.push("type.equals=" + type);
                        }
                        if (query && query.length > 0) {
                            requestParams = __spreadArrays(requestParams, query);
                        }
                        else {
                            // exclude the featured draw if no search filter applied
                            requestParams.push('excludeFeatured=true');
                        }
                        url = PATH + "/draws/second-chance?" + requestParams.join('&');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _b.sent();
                        last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = Math.ceil((response.totalElements - 1) / response.size);
                        if (query && query.length > 0) {
                            // don't change page params for filtered results
                            last = response.last;
                            totalPages = response.totalPages;
                        }
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_5 = _b.sent();
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawWithAdditionalInformation = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/additional-information";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawPrizes = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/prizes";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawPrizesWithContent = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/prizes-with-content";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawPrizesWithWinners = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/prizes-with-winners";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchLatestDrawHistory = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/latest-live-draw-history";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchDrawEntryDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/draws/" + id + "/detail";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_11 = _a.sent();
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchSweepStakeDraws = function (_a) {
        var page = _a.page, size = _a.size, sort = _a.sort;
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, last, totalPages, error_12;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestParams = ["page=" + (page || 0), "size=" + (size || 9999)];
                        if (sort) {
                            requestParams.push("sort=" + sort);
                        }
                        else {
                            requestParams.push("sort=end,desc");
                            requestParams.push("sort=name,asc");
                        }
                        url = PATH + "/draws/sweepstakes?end.lessOrEqualThan=" + TimeUtil_1.nowUtc().toISOString() + "&" + requestParams.join('&');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _b.sent();
                        last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
                        totalPages = Math.ceil((response.totalElements - 1) / response.size);
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: last,
                                    totalElements: response.totalElements,
                                    totalPages: totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_12 = _b.sent();
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.submitOptOutPrize = function (optOut) {
        return __awaiter(this, void 0, void 0, function () {
            var error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.put({
                                url: PATH_V2 + "/draws/prize/opt-out",
                                body: optOut
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_13 = _a.sent();
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.submitOptOutPrizes = function (optOutList) {
        return __awaiter(this, void 0, void 0, function () {
            var error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.put({
                                url: PATH_V2 + "/draws/prizes/opt-out",
                                body: optOutList
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_14 = _a.sent();
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.submitOptOutDraw = function (optOut) {
        return __awaiter(this, void 0, void 0, function () {
            var error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.put({
                                url: PATH_V2 + "/draws/opt-out",
                                body: optOut
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_15 = _a.sent();
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DrawsService.fetchOptOutPreferences = function (drawIds) {
        return __awaiter(this, void 0, void 0, function () {
            var error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH_V2 + "/draws/opt-out/preferences",
                                body: drawIds
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_16 = _a.sent();
                        throw error_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return DrawsService;
}());
exports.DrawsService = DrawsService;
//# sourceMappingURL=draws-service.js.map